document.addEventListener("DOMContentLoaded", function () {
  const faqItems = document.querySelectorAll(".product-faq-item-title");

  faqItems.forEach(function (item) {
    item.addEventListener("click", function () {
      const specsItem = this.closest(".product-faq-item");
      // 只切换当前项目，不关闭其他项目
      specsItem.classList.toggle("expanded");
    });
  });
});
